<script lang="ts" setup>
import { TirPmSvg } from "tir-components";
import { ParentTaskModel } from "./models";
import { computed, PropType } from "vue";
import { ConnectIcon } from "tir-style-system/icons/outline";
import { RouterLink, useRouter } from "vue-router";

/**Маршруты */
const router = useRouter();

/**Параметры */
const props = defineProps({
  /**Информация о задаче */
  task: { type: Object as PropType<ParentTaskModel> },
  /**Короткий вариант отображения плашки */
  isShort: { type: Boolean },
});

/**Задача валидна */
const validTask = computed(
  () => props.task?.QueueTaskId && !props.task?.QueueTaskId?.includes("00000"),
);
/**Id проекта */
const projectId = computed(() => router.currentRoute.value?.params?.projectId);
/**Путь к задаче */
const taskPath = computed(() => {
  if (!validTask.value) return "";
  return router.resolve({
    name: "task-detail",
    params: {
      taskId: props.task?.TaskId,
      projectId: projectId.value,
      namespaceId: props.task?.NamespaceId,
      queueId: props.task?.QueueTaskId || "",
    },
  });
});
</script>
<template>
  <RouterLink v-if="validTask" :to="taskPath">
    <div class="parent-task-plate" :class="{ short: isShort }">
      <TirPmSvg :url="task.IconUrl" class="parent-task-plate__namespace-icon" :color="task.Color" />
      <ConnectIcon v-if="isShort" class="parent-task-plate__icon" />
      <div v-text="task.TaskId" class="parent-task-plate__code" />
      <template v-if="!isShort">
        <div class="parent-task-plate__tip">
          <ConnectIcon class="parent-task-plate__icon" />
          Родительская задача
        </div>
        <div v-text="task.Name" class="parent-task-plate__name" />
      </template>
    </div>
  </RouterLink>
</template>
<style lang="scss">
.parent-task-plate {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  max-width: 46.5625rem;
  height: 2.25rem;
  padding: 0 0.625rem;
  background-color: var(--bg-base);
  border: 1px solid var(--neutral-translucent-10);
  color: var(--text-primary);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  white-space: nowrap;
  cursor: pointer;
  &.short {
    gap: 0.5rem;
    min-height: 3rem;
  }
  &__namespace-icon {
    min-width: 1.5rem;
    min-height: 1.5rem;
    svg {
      min-width: 1.125rem;
      min-height: 1.125rem;
    }
  }
  &__code {
    min-width: 2rem;
    font-weight: 500;
  }
  &__tip {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    color: var(--text-secondary);
  }
  &__icon {
    width: 1rem;
    height: 1rem;
    fill: var(--text-secondary);
  }
  &__name {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
